var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaceFailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.524,
    height: 55,
    viewBox: "0 0 44.524 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICONOS-15",
    transform: "translate(-7.05 -3.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_837",
    "data-name": "Trazado 837",
    d: "M19.36,33.3a1.312,1.312,0,0,1-.524-2.514l.851-.367a15.757,15.757,0,0,1,13.344.406,1.306,1.306,0,1,1-1.179,2.331,13.187,13.187,0,0,0-11.131-.34l-.851.367a1.191,1.191,0,0,1-.511.1Z",
    transform: "translate(3.404 7.991)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_838",
    "data-name": "Trazado 838",
    d: "M47.645,3.31H10.979A3.94,3.94,0,0,0,7.05,7.239V54.381a3.94,3.94,0,0,0,3.929,3.929H47.645a3.94,3.94,0,0,0,3.929-3.929V7.239A3.94,3.94,0,0,0,47.645,3.31ZM10.979,5.929h5.893v5.225a1.319,1.319,0,0,1-1.323,1.323H10.324a1.241,1.241,0,0,0-.655.2V7.239A1.313,1.313,0,0,1,10.979,5.929ZM48.955,54.381a1.313,1.313,0,0,1-1.31,1.31H10.979a1.313,1.313,0,0,1-1.31-1.31V14.9a1.241,1.241,0,0,0,.655.2h5.225a3.946,3.946,0,0,0,3.942-3.942V5.929H47.645a1.313,1.313,0,0,1,1.31,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_839",
    "data-name": "Trazado 839",
    d: "M20.6,23.225l1.179-1.244a1.306,1.306,0,1,0-1.9-1.794L18.79,21.326,17.7,20.187a1.306,1.306,0,1,0-1.9,1.794l1.179,1.244L15.8,24.469a1.3,1.3,0,0,0,.956,2.2,1.319,1.319,0,0,0,.956-.406L18.8,25.124l1.087,1.139a1.3,1.3,0,0,0,.956.406,1.335,1.335,0,0,0,.9-.354,1.3,1.3,0,0,0,.052-1.846l-1.179-1.244Z",
    transform: "translate(2.599 5.097)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_840",
    "data-name": "Trazado 840",
    d: "M31.6,23.225l1.179-1.244a1.306,1.306,0,1,0-1.9-1.794L29.79,21.326,28.7,20.187a1.306,1.306,0,1,0-1.9,1.794l1.179,1.244L26.8,24.469a1.3,1.3,0,0,0,.956,2.2,1.319,1.319,0,0,0,.956-.406L29.8,25.124l1.087,1.139a1.3,1.3,0,0,0,.956.406,1.335,1.335,0,0,0,.9-.354,1.3,1.3,0,0,0,.052-1.846l-1.179-1.244Z",
    transform: "translate(6.004 5.097)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceFailIcon);
export default __webpack_public_path__ + "static/media/faceFailIcon.96aca22d2096c355f2134fc04bdc7cd1.svg";
export { ForwardRef as ReactComponent };